import { VariantProps, cva } from 'class-variance-authority'

const $badge = cva(
  'text-[12px] rounded-full h-[18px] flex items-center justify-center gap-2 px-2',
  {
    variants: {
      intent: {
        primary: 'font-medium text-dark-control-base bg-dark-control-base/20',
        secondary:
          'text-dark-dim bg-dark-border-solid border border-dark-elevated',
      },
    },
  }
)

type BadgeProps = {
  children: React.ReactNode
  asChild?: boolean
} & React.HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof $badge>

export const Badge = ({
  children,
  intent = 'primary',
  asChild,
  className,
  ...props
}: BadgeProps) => {
  const Comp = asChild ? 'span' : 'div'
  return (
    <Comp {...props} className={$badge({ intent, className })}>
      {children}
    </Comp>
  )
}
